angular.module('AccountingBoxApp')
  .controller('PurchasesCtrl', function ($scope, Purchase) {
   // $scope.message = 'Hello';
     var vm = this;
   // var purchase= new Purchase();
    var purchase = new Purchase();
    purchase.description = 'sesdasdf';
    purchase.journalDate = new Date();
    vm.save = function(){
    Purchase.upsert(purchase);
    };
    vm.purchase = purchase;
  });
